import { createGlobalState } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { GlobalProxy } from '@patsnap/hiro-event-proxy';
import { ref } from 'vue';

export const useHiro = createGlobalState(() => {
    const hiroIsLoaded = ref(false);
    const globalProxy = injectService<GlobalProxy>(GlobalProxy);
    globalProxy.eventProxy.on('loaded', () => {
        hiroIsLoaded.value = true;
    });

    return {
        hiroIsLoaded,
    };
});